import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import './RemoveVenu.css';

const VenueList = () => {
  const [venues, setVenues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deletingId, setDeletingId] = useState(null);

  useEffect(() => {
    fetchVenues();
  }, []);

  const fetchVenues = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/venues`);
      setVenues(response.data);
      setError(null);
    } catch (error) {
      console.error('Error fetching venues:', error);
      setError('Failed to fetch venues. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#5e71f6',
      cancelButtonColor: '#dc2626',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      try {
        setDeletingId(id);
        await axios.delete(`${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/venues/${id}`);
        setVenues(venues.filter(venue => venue._id !== id));
        Swal.fire({
          icon: 'success',
          title: 'Deleted!',
          text: 'Venue removed successfully!',
          confirmButtonColor: '#5e71f6',
        });
      } catch (error) {
        console.error('Error removing venue:', error);
        Swal.fire({
          icon: 'error',
          title: 'Failed!',
          text: 'Failed to remove venue.',
          confirmButtonColor: '#ef4444',
        });
      } finally {
        setDeletingId(null);
      }
    }
  };

  if (loading) {
    return (
      <div className="paper-list-wrapper">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading venues...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="paper-list-wrapper">
        <div className="error-container">
          <div className="error-icon">!</div>
          <p className="error-message">{error}</p>
          <button className="retry-button" onClick={fetchVenues}>
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="paper-list-wrapper">
      <div className="venue-list-container">
        {/* Header Section */}
        <div className="header-section">
          <h1 className="paper-list-title">Venue Management</h1>
          <p className="paper-list-subtitle">
            Manage and remove venue details from the system
          </p>
        </div>

        {venues.length === 0 ? (
          <div className="no-venues-box">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" viewBox="0 0 16 16">
              <path d="M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5z"/>
            </svg>
            <h3>No Venues Available</h3>
            <p>There are currently no venues added to the system. Add a venue to get started.</p>
          </div>
        ) : (
          <div className="venues-grid">
            {venues.map(venue => (
              <div key={venue._id} className="venue-card">
                <div className="venue-image-container">
                  <img 
                    src={venue.imageUrl} 
                    alt={venue.description} 
                    className="venue-image" 
                  />
                </div>
                <div className="venue-content">
                  <p className="venue-description">{venue.description}</p>
                </div>
                <div className="venue-actions">
                  <button 
                    className="remove-button" 
                    onClick={() => handleRemove(venue._id)}
                    disabled={deletingId === venue._id}
                  >
                    {deletingId === venue._id ? (
                      <>
                        <div className="button-spinner"></div>
                        Deleting...
                      </>
                    ) : (
                      <>
                        <svg className="btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                        Remove Venue
                      </>
                    )}
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default VenueList;
